import * as React from 'react'
import { inject, observer } from 'mobx-react'
import posed, { PoseGroup } from 'react-pose'
import { IntlShape, injectIntl } from 'react-intl'

import { CloseIcon } from 'src/components/UI/Icon/Icon'
import messages from 'src/components/Cart/messages'

import styles from './Cart.module.scss'
import CartItem from './CartItem'
import CartSummary from './CartSummary'
import LanguageContext from '../LanguageContext'

type Props = {
  cart?: any
  ui?: any
  intl: IntlShape
}

const Wrapper = posed.div({
  active: {
    left: 0,
    transition: {
      duration: 350,
    },
  },
  inactive: {
    left: '100%',
    transition: {
      duration: 350,
    },
  },
})

const Background = posed.div({
  enter: { opacity: 0.6 },
  exit: { opacity: 0 },
})

@inject('cart')
@inject('ui')
@observer
class Cart extends React.Component<Props> {
  contentRef: React.RefObject<HTMLDivElement>
  wrapperRef: React.RefObject<HTMLDivElement>

  constructor(props: Props) {
    super(props)
    this.wrapperRef = React.createRef()
    this.contentRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event: any) => {
    if (
      this.wrapperRef &&
      this.wrapperRef.current &&
      this.wrapperRef.current.contains(event.target) &&
      this.contentRef &&
      this.contentRef.current &&
      !this.contentRef.current.contains(event.target)
    ) {
      this.closeMenu()
    }
  }

  closeMenu = () => {
    const { ui } = this.props
    ui.setActiveMenu('')
  }

  render() {
    const { cart, ui, intl } = this.props
    const active = ui.activeMenu === 'cart'
    const items = cart.items

    const { formatMessage } = intl

    return (
      <React.Fragment>
        <PoseGroup>
          {active && (
            <Background
              key="background"
              id="background"
              className={styles.background}
            />
          )}
        </PoseGroup>
        <Wrapper
          pose={active ? 'active' : 'inactive'}
          ref={this.wrapperRef}
          className={styles.cartOverlay}
        >
          <div ref={this.contentRef} className={styles.cartMenu}>
            <div className={styles.cartHeader}>
              <p>{formatMessage(messages.cart)}</p>
              <div onClick={this.closeMenu} className={styles.closeButton}>
                <CloseIcon width={20} height={20} color="black" />
              </div>
            </div>
            {items && items.length > 0 ? (
              <React.Fragment>
                <div className={styles.cartItems}>
                  <div>
                    {items.map((item: any) => (
                      <LanguageContext.Consumer key={item.line}>
                        {context => (
                          <CartItem
                            handleClick={this.closeMenu}
                            cart={cart}
                            item={item}
                            key={item.line}
                            locale={context.locale}
                          />
                        )}
                      </LanguageContext.Consumer>
                    ))}
                  </div>
                </div>
                <CartSummary handleClick={this.closeMenu} />
              </React.Fragment>
            ) : (
                <div className={styles.empty}>{formatMessage(messages.emptyCart)}</div>
              )}
          </div>
        </Wrapper>
      </React.Fragment>
    )
  }
}

export default injectIntl(Cart)
